module.exports = __webpack_public_path__ + "static/analyse-e76e660156e17fd5d72eab50b96108ab.gif";